import React from 'react';
import { get } from 'lodash';
import { Chip, Typography, Tooltip, makeStyles } from '@material-ui/core';
import addressToString from 'services/helpers/addressToString';

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: '430px',
    padding: 10,
    borderRadius: '16px',
    lineHeight: 1.2,
    zIndex: 3,
    fontSize: '16px',
  },
  secondary: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
  },
  warehouseHeader: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  platform: {
    height: 18,
    maxWidth: `calc(100% - ${theme.spacing(1)}px)`,
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.action.hover,
    fontSize: 12,

    '& .MuiChip-label': {
      overflow: 'hidden',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
}));

const WarehouseField = ({
  record = {},
  source,
  basePath,
  className,
}: {
  record?;
  source: string;
  basePath?;
  className?;
  label?;
}) => {
  const classes = useStyles();
  const isReturn = get(record, 'type').toLowerCase() === 'return';
  const platform = get(record, 'platform');
  const hasPlatform = typeof platform === 'string' && platform.trim().length > 0;

  const parsedAddress = addressToString(get(record, source), {
    withName: true,
  });

  return (
    <>
      <div className={classes.warehouseHeader}>
        <Typography className={classes.secondary} data-test="warehouse">
          {isReturn ? 'RETURN TO' : 'FROM'}
        </Typography>
        {hasPlatform && <Chip className={classes.platform} label={platform} />}
      </div>
      <Tooltip
        title={parsedAddress}
        placement={'bottom-start'}
        enterDelay={300}
        classes={{ tooltip: classes.tooltip }}>
        <Typography className={className} data-test="warehouse">
          {get(record, `${source}.warehouseName`)}
        </Typography>
      </Tooltip>
    </>
  );
};

export default WarehouseField;
